<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1400px"
      title="修改"
      show-save-button
      id-key="ReportId"
      :data="data"
      @closed="onClosed"
      @edit-opened="openEditOpened"
      :showSaveButton="false"
    >
    <!-- :get-data-func="api.info" -->
      <template slot="form">
        <div class="row-tb-head">
            <div class="flex">
                <div class="mrx36 flex">
                    <div style="min-width: 60px;">工单编码</div>
                    <el-input v-model="workNo" placeholder="输入工单编码" @change="chooseSets"></el-input>
                </div>
                <span style="margin-right: 80px;">可以扫码或者输入后自动回车显示到下面表格</span>
                <div class="mrx36">
                    <span class="inline_block">报工人：</span>
                    <span class="inline_block">{{data.Dts.length > 0? operator : ''}}</span>
                </div>
            </div>
        </div>
        <el-table class="table-line tb-c-head" :data="data.Dts" border v-if="displayMode === 1">
          <el-table-column label="订单编号" prop="OrderNo" min-width="170" show-overflow-tooltip />
          <el-table-column label="工单编号" prop="WorkDocNo" min-width="170" show-overflow-tooltip />
          <el-table-column label="模具编号" prop="MouldNo" min-width="120" show-overflow-tooltip />
          <el-table-column label="模具名称" prop="MouldName" min-width="120" />
          <el-table-column label="模数" prop="Quantity" min-width="70" />
          <el-table-column label="排产模数" prop="ThisPlanQuantity" width="80" />
          <el-table-column label="已报工数" prop="ThisReportQuantity" width="90" />
          <el-table-column label="完成率(%)" prop="CompletionRate" width="100" />
          <el-table-column label="工序方案" prop="ProgrammeName" width="100" />
          <el-table-column label="工序顺序" prop="ProcessSn" width="100" />
          <el-table-column label="工序名称" prop="ProcessName" width="100" />
          <el-table-column label="本次报工数" prop="ThisReportQuantityNumber" width="100" >

            <template slot-scope="{ row }">
                <el-input v-model="row.ThisReportQuantityNumber" placeholder="请输入本次报工数"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-table class="table-line tb-c-head" :data="data.Dts" border v-if="displayMode === 2">
          <el-table-column label="订单编号" prop="OrderNo" min-width="170" show-overflow-tooltip />
          <el-table-column label="工单编号" prop="WorkDocNo" min-width="170" show-overflow-tooltip />
          <el-table-column label="存货编号" prop="ProductNo" min-width="120" show-overflow-tooltip />
          <el-table-column label="存货名称" prop="ProductName" min-width="120" />
          <el-table-column label="生产数量" prop="Quantity" min-width="70" />
          <el-table-column label="排产数量" prop="ThisPlanQuantity" width="80" />
          <el-table-column label="已报工数" prop="ThisReportQuantity" width="90" />
          <el-table-column label="完成率(%)" prop="CompletionRate" width="100" />
          <el-table-column label="工序方案" prop="ProgrammeName" width="100" />
          <el-table-column label="工序顺序" prop="ProcessSn" width="100" />
          <el-table-column label="工序名称" prop="ProcessName" width="100" />
          <el-table-column label="本次报工数" prop="ThisReportQuantityNumber" width="100" >

            <template slot-scope="{ row }">
                <el-input v-model="row.ThisReportQuantityNumber" placeholder="请输入本次报工数"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  props: {
    displayMode: {
        type: Number,
        default: 1
    }
  },
  data() {
    return {
      api: require("@/api/pu/report").default,
      // api: require("@/api/sy/user").default,
      workNo: "",
      data: {
        
        ReportId: 0,
        PlanId: null,
        Stage: 0,
        StartDate: null,
        EndDate: null,
        ProcessName: "",
        ReportDate: null,
        Dts: [
        ],
        Materials: [],
        Products: [],
        operator: ''
      },
    };
  },
  computed: {},
  methods: {
    chooseSets(data) {
      this.api.getWorkDocProductReportList({
        WorkDocNo: data
      }).then(res => {
        this.data.Dts = []
        if (res.Data && res.Data.length > 0) {
          res.Data.forEach(item => {
            this.data.Dts.push(item)
          })
        } else {
          this.$message.warning('暂无数据！')
        }
      }).catch(err => {
        this.$message.error(err)
        // console.log(err);
      })
      // if (data != '') {
      //   this.data.Dts = this.workInfo.filter(obj => {
      //     const isFilter = data.split('').some((item, index) => {
      //       return  obj.WorkDocNo.split('')[index] !== item
      //     })
      //     return !isFilter
      //   })
      // } else {
      //   this.data.Dts = this.workInfo;
      // }
    },
    onClosed() {
      this.data.Dts = [];
      this.data.Materials = [];
      this.data.Products = [];
      this.workNo = '';
    },
    async openEditOpened(data) {
      console.log(data, 'reportData');
      this.operator = JSON.parse(localStorage.getItem("loginInfo")).UserName;
      // this.data.Dts = data.infoData;
      let o = {};
      let infoData = [];
      const ids = data.checkList.map(item => item.WorkDocId);
      o = {WorkDocIds: ids};
      const res = await this.api.getWorkDocProductReportList(o);
      if (!res.IsSucc) return this.$message.error(res.Msg);
      if (res.Data && res.Data.length > 0) {
        infoData = res.Data;
      }
        // this.edit({infoData: this.$refs.toCheckList.workInfo, batch: true})
      this.data.Dts = infoData.map(item => {
        return {
          ...item,
          ThisReportQuantityNumber: 0
        }
      });
      this.data.batch = data.batch;
    },
    async onSubmit() {
      let isReturn = false;
      const arr = this.data.Dts.map(item => {
        if (item.ThisReportQuantityNumber == null || item.ThisReportQuantityNumber == undefined) {
          this.$message.error('请输入本次报工数')
          isReturn = true;
        }
        return {
          WorkDocId: item.WorkDocId,
          ThisReportQuantity: Number(item.ThisReportQuantityNumber),
        }
      });
      if (isReturn) return
      const res = await this.api.quantityUpdate({WorkDocId: arr[0].WorkDocId, ThisReportQuantity: arr[0].ThisReportQuantity});
      if (!res.IsSucc) return this.$message.error(res.Msg)
      this.$message.success('保存成功！')
      this.$refs.dialog.isChange = false;
      this.close();
      this.$emit('saved');
    },
    close() {
      this.$refs.dialog.close();
    }
  },
};
</script>

<style lang="scss" scoped>
.flex{
    display: flex;
}
.inline_block{
    display: inline-block;
}
.mrx36{
    margin-right: 36px;
}
</style>